import type { ReactNode } from 'react';

import type { IconName } from '../../../assets/Icon/Icon';
import { styled } from '../../../stitches.config';
import { ChassisBracket } from './ChassisBracket';
import { chassisVars } from './utils';

const ChassisSectionContent = styled('div', {
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  gap: `$${chassisVars.gap.column}`,
});
ChassisSectionContent.displayName = 'ChassisSectionContent';

const ChassisSectionContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});
ChassisSectionContainer.displayName = 'ChassisSectionContainer';

export type ChassisSectionProps = {
  children?: ReactNode;
  icon?: IconName;
  label?: ReactNode;
};

export function ChassisSection({ label, icon, children }: ChassisSectionProps) {
  return (
    <ChassisSectionContainer>
      <ChassisBracket label={label} icon={icon} />
      <ChassisSectionContent>{children}</ChassisSectionContent>
    </ChassisSectionContainer>
  );
}
